import { BasicStoreApi } from './instances';

type IterableNotificationEvents<T> = {
  event_type: string;
  resource: {
    user_id?: string | number;
    email: string;
    data_fields: Record<string, T>;
  };
};

// Create Iterable notification events
export const sendNotificationEvent = async <T>(
  payload: IterableNotificationEvents<T>,
) => {
  const response = await BasicStoreApi.post<{
    data: IterableNotificationEvents<T>;
  }>('/v3/notification_events', payload);
  return response.data;
};
